export const  validateHaveDisability = (watchHaveDisability: string) : boolean => {
 return watchHaveDisability === "NO" ? true : false;
}